import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

import "./gridEvent.css"

function InspectionGroup(props) {
    const { id, selectMstGrid, groupByMaterialGridSetting } = props;

    const [api, setApi] = useState();
    const [grid, setGrid] = useState();
    const [, setOnSelectGrid] = useState();

    const { t } = useTranslation();

    useEffect(() => {
        if(api) {
            api.refresh();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectMstGrid]);

    useEffect(() => {
        (async () => {
            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setOnSelectGrid(grid.selectedItems[0]);
                        groupByMaterialGridSetting(grid.selectedItems[0]);
                    } else {
                        setOnSelectGrid(undefined);
                        groupByMaterialGridSetting(undefined);
                    };
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setOnSelectGrid(grid.selectedItems[0]);
                        groupByMaterialGridSetting(grid.selectedItems[0]);
                    } else {
                        setOnSelectGrid(undefined);
                        groupByMaterialGridSetting(undefined);
                    };
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };

    const onModifyUrl = (url) => {
        let modifyUrl = 'api/MomSysInspectionRslt';
        modifyUrl += '/selfInspectionGroupByMaterial';
        modifyUrl += '/null';
        modifyUrl += `/${selectMstGrid.materialCode}`;
        modifyUrl += `/${selectMstGrid.materialCodeVer}`;

        return modifyUrl;
    };

    return (
        <>
            <BasicCrudScreenType
                id={id}
                table="MomSysInspectionRslt"
                view="SelfInspectionGroupByMaterialView"
                onApiInitialized={onApiInitialized}
                onInitialized={onInitialized}
                onModifyViewUrl={(url) => onModifyUrl(url)}
                headerTitle={t("term.momSysInspectionGroup")}
                noCreate
                noEdit
                noDelete
                noExcel
            />
        </>
    );
}

export default InspectionGroup;
